import React from "react";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

export default function CampaignMenu({ activeItem }) {
  return (
    <li className="nav-item">
      <Link
        to="/campaigns/all"
        className={`nav-link  d-flex
          ${sidebarHelper.checkActiveItem(activeItem, "all-campaigns")} `}
      >
        <i className="nav-icon hl-notification"></i>
        <p>کمپین ها</p>
      </Link>
    </li>
  );
}
